import { render } from "./AppMenuHeader.vue?vue&type=template&id=2182ec64"
import script from "./AppMenuHeader.vue?vue&type=script&lang=js"
export * from "./AppMenuHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__